import { IUiPropertiesDTO } from "@mm-frontend/clickstream-client-js";

export enum EEventType {
  PAGE_VIEW = 'PAGE_VIEW',
  SIGNIN_BEGIN = 'SIGNIN_BEGIN',
  START_BUSINESS = 'START_BUSINESS',
  REGISTRATION_BEGIN = 'REGISTRATION_BEGIN',
  MANUAL = 'MANUAL',
  AGREEMENT = 'AGREEMENT',
  KNOW_MORE = 'KNOW_MORE',
  DP_BEGIN = 'DP_BEGIN',
  OFFER_SERVICES_BEGIN = 'OFFER_SERVICES_BEGIN',
  BECOME_SUPPLIER_BEGIN = 'BECOME_SUPPLIER_BEGIN',
  HELPER_BOT_BEGIN = 'HELPER_BOT_BEGIN',
  SCROLL_ALL = 'SCROLL_ALL',
  PHS_BANNER_VIEW = 'PHS_BANNER_VIEW',
}

export enum EPrefixedEventType {
  REGISTRATION_BEGIN_FOOTER = 'REGISTRATION_BEGIN_FOOTER',
  LOGISTICS_DETAILS_OFFERS = "LOGISTICS_DETAILS_OFFERS",
  OFFER_SERVICES_BEGIN_FOOTER = 'OFFER_SERVICES_BEGIN_FOOTER',
  DP_BEGIN_FOOTER = "DP_BEGIN_FOOTER",
  BRANDING_DETAILS_OFFERS = "BRANDING_DETAILS_OFFERS",
  BUSINESS_BOT_BEGIN_QUESTIONS = "BUSINESS_BOT_BEGIN_QUESTIONS",
  BECOME_SUPPLIER_BEGIN_FOOTER = "BECOME_SUPPLIER_BEGIN_FOOTER",
}

type TPrefixedUIProperties = {
  [key in EPrefixedEventType]?: IUiPropertiesDTO;
};

type TUIProperties = {
  [key in EEventType]?: IUiPropertiesDTO;
};

export type TLandingUIProperties = TPrefixedUIProperties & TUIProperties

export interface IEventsMap {
  [EEventType.PAGE_VIEW]: {
    utm_source: string,
    utm_medium: string,
    utm_campaign: string,
    utm_content: string
  };
  [EEventType.SIGNIN_BEGIN]: null;
  [EEventType.START_BUSINESS]: null;
  [EEventType.REGISTRATION_BEGIN]: null;
  [EEventType.MANUAL]: null;
  [EEventType.AGREEMENT]: null;
  [EEventType.KNOW_MORE]: null;
  [EEventType.DP_BEGIN]: null;
  [EEventType.OFFER_SERVICES_BEGIN]: null;
  [EEventType.BECOME_SUPPLIER_BEGIN]: null;
  [EEventType.HELPER_BOT_BEGIN]: null;
  [EEventType.SCROLL_ALL]: null;
}
